
import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

interface PrivateRouteProps {
  element?: React.ReactNode;
  children?: React.ReactNode;
}

export const PrivateRoute = ({ element, children }: PrivateRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    toast.error("Authentication required. Please sign in to access this page.");
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return element ?? children ?? <Outlet />;
};

export default PrivateRoute;
